export const autoResizeTextarea = (el: HTMLTextAreaElement | null, maxHeight?: number) => {
    if (!el) return;
    el.style.height = 'auto';
    const next = el.scrollHeight;
    if (typeof maxHeight === 'number' && Number.isFinite(maxHeight) && maxHeight > 0) {
        const capped = Math.min(next, maxHeight);
        el.style.height = `${capped}px`;
        el.style.overflowY = next > maxHeight ? 'auto' : 'hidden';
        return;
    }
    el.style.height = `${next}px`;
    el.style.overflowY = 'hidden';
};
